<template>
<div class="fc-page mg-page mg-goods_list"><nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb"/></nav><header class="fc-heading"><div class="fc-child-heading"><h1>商品管理</h1><p>维护商品信息与状态，统一管理教学物资</p></div><div class="mg-heading-actions"><v-btn  @click="showAddDialog" color="#d9363e" depressed class="mg-create">添加商品</v-btn></div></header><section class="fc-filters" aria-label="商品管理筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>按条件查找需要的记录</span></div><form @submit.prevent="queryClicked"><div class="fc-filter-grid"><div class="fc-filter-cell"><v-text-field clearable dense label="商品名称" outlined v-model="query.goodsName" color="#d9363e" aria-label="商品名称">
							</v-text-field></div>
<div class="fc-filter-cell"><v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								transition="scale-transition" offset-y
								min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined color="#d9363e" aria-label="创建开始日期"></v-text-field>
								</template>
								<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e">
								</v-date-picker>
							</v-menu></div>
<div class="fc-filter-cell"><v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
								transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.end" label="创建结束日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined color="#d9363e" aria-label="创建结束日期"></v-text-field>
								</template>
								<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn" color="#d9363e">
								</v-date-picker>
							</v-menu></div>
<div class="fc-filter-cell"><v-select :items="statusList" v-model="query.status"
							item-text="text" item-value="value" label="状态" dense outlined color="#d9363e" aria-label="状态"></v-select></div></div><div class="fc-filter-bottom"><span>设置条件后点击查询</span><v-btn type="submit" color="#d9363e" dark depressed class="mg-query"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></form></section>
    <v-alert v-if="canViewStock && stockInfo.error" type="warning" dense text class="mg-stock-error">
      {{stockInfo.error}} <v-btn text small color="#d9363e" @click="fetchCurrentPageStock">重试库存</v-btn>
    </v-alert>
    <section class="fc-records" aria-label="商品列表"><div class="fc-list-heading"><h3>商品列表</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span><span v-if="canViewStock" class="fc-list-note">库存所属：{{stockShopName || '当前校区'}}</span></div><v-data-table :headers="goodsHeaders" :items="data.list" :loading="query.loading" class="fc-table mg-table fc-has-actions"
			disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......" :mobile-breakpoint="0" no-data-text="暂无符合条件的记录">

			<template v-slot:item.status="{item}">
				<v-chip :color="classStatusColor(item.status)" small label outlined>{{ classStatusName(item.status) }}</v-chip>
			</template>
			<template v-slot:item.masterImg="{item}">
				<v-avatar rounded class="my-1" style="cursor: pointer;">
					<v-img v-if="item.masterImg" :src="imgPrev + item.masterImg" width="50" height="50" @click="showImageViewer(item.masterImg)"></v-img>
				</v-avatar>
			</template>

			<template v-slot:item.action="{item}">
				<v-btn v-if="canViewStock && stockInfo.canChange" @click.stop="showStockAdjustment(item)" :disabled="stockInfo.loading || !stockInfo.loaded" color="#d9363e" small outlined>库存调整</v-btn>
				<v-btn @click.stop="showUpdate(item)" color="#d9363e" small depressed>修改</v-btn>

				<v-btn v-if="item.status == '1'" @click.stop="changeStatus(item,'0')" color="error" small class="ml-2" depressed>作废</v-btn>

				<v-btn v-if="item.status == '0'" @click.stop="changeStatus(item,'1')" color="success" small class="ml-2" depressed>启用</v-btn>
			</template>

            <template v-slot:item.currentStock="{item}"><span class="fc-number">{{stockInfo.loading ? '加载中' : stockInfo.loaded ? stockQuantity(item) : '—'}}</span></template>
		</v-data-table><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
						outlined v-model="query.size" color="#d9363e" aria-label="每页数量" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><div v-if="Math.ceil(data.total/query.size)>0" class="mg-pagination"><v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
						:total-visible="5" v-model="query.page" color="#d9363e" /></div></div></section><v-dialog title="添加商品" v-model="add.dialog" max-width="600" scrollable>
		<v-card min-height="300" class="fc-dialog-card mg-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-package-variant-closed</v-icon></span><div class="mg-dialog-title"><h2><span>添加商品信息</span></h2><p>完善信息后保存修改</p></div><v-spacer/><v-btn icon aria-label="关闭添加商品" @click="add.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">
				<v-row dense>
					<v-col cols="12">
						<v-text-field label="商品名称" v-model="add.goods.goodsName" dense outlined color="#d9363e" aria-label="商品名称"></v-text-field>
					</v-col>
					<v-col cols="12" v-if="!this.add.goods.masterImg">
						<cutImageUpload :show="true" title="上传商品图片" @success="addUploadSuccess"></cutImageUpload>
					</v-col>
					<v-col cols="12" v-if="add.goods.masterImg">
						<v-img :src="imgPrev+add.goods.masterImg" height="200" width="200">
							<v-app-bar flat color="rgba(0, 0, 0, 0.2)" height="25">
								<v-spacer></v-spacer>
								<v-btn color="white" x-small icon @click="add.goods.masterImg=''">
									<v-icon color="red">mdi-close-circle</v-icon>
								</v-btn>
							</v-app-bar>
						</v-img>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="add.dialog=false" depressed>取消</v-btn>
				<v-btn @click="submitAddClass" color="#d9363e" depressed class="fc-confirm">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
<v-dialog title="修改商品信息" v-model="update.dialog" max-width="600" persistent scrollable>
		<v-card class="fc-dialog-card mg-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-package-variant-closed</v-icon></span><div class="mg-dialog-title"><h2><span>修改商品信息</span></h2><p>完善信息后保存修改</p></div><v-spacer/><v-btn icon aria-label="关闭修改商品信息" @click="update.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">
				<v-row dense>
					<v-col cols="12" class="mt-3">
						<v-text-field label="商品名称" v-model="update.goods.goodsName" dense outlined color="#d9363e" aria-label="商品名称"></v-text-field>
					</v-col>

					<v-col cols="12" v-if="!update.goods.masterImg">
						<cutImageUpload :show="true" title="上传商品图片" @success="editUploadSuccess"></cutImageUpload>
					</v-col>
					<v-col cols="12" v-if="update.goods.masterImg">
						<v-img :src="imgPrev+update.goods.masterImg" height="200" width="200">
							<v-app-bar flat color="rgba(0, 0, 0, 0.2)" height="25">
								<v-spacer></v-spacer>
								<v-btn color="white" x-small icon @click="update.goods.masterImg=''">
									<v-icon color="red">mdi-close-circle</v-icon>
								</v-btn>
							</v-app-bar>
						</v-img>
					</v-col>

				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="update.dialog=false" depressed>取消</v-btn>
				<v-btn @click="submitUpdateGoods" color="#d9363e" depressed class="fc-confirm">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
    <v-dialog v-model="stockAdjustment.dialog" :persistent="stockAdjustment.saving" max-width="600" scrollable>
      <v-card class="fc-dialog-card mg-dialog">
        <v-card-title class="fc-dialog-header">
          <span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-package-variant-closed</v-icon></span>
          <div class="mg-dialog-title"><h2>库存调整</h2><p>{{stockShopName}} · 当前库存 {{stockAdjustment.currentStock}}</p></div>
          <v-spacer/><v-btn icon aria-label="关闭库存调整" :disabled="stockAdjustment.saving" @click="stockAdjustment.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="fc-dialog-body">
          <v-row dense>
            <v-col cols="12"><v-text-field label="商品" :value="stockAdjustment.goodsName" readonly dense outlined/></v-col>
            <v-col cols="12"><v-radio-group v-model="stockAdjustment.form.inOut" row label="调整方式" :disabled="stockAdjustment.saving"><v-radio label="入库" value="1" color="#d9363e"/><v-radio label="出库" value="2" color="#d9363e"/></v-radio-group></v-col>
            <v-col cols="12" sm="6"><v-text-field label="数量" v-model="stockAdjustment.form.quantity" type="number" min="1" max="10000" step="1" :disabled="stockAdjustment.saving" dense outlined color="#d9363e"/></v-col>
            <v-col cols="12" sm="6"><v-text-field label="交接人" v-model="stockAdjustment.form.bizUserName" :disabled="stockAdjustment.saving" dense outlined color="#d9363e"/></v-col>
            <v-col cols="12"><v-text-field label="备注" v-model="stockAdjustment.form.memo" :disabled="stockAdjustment.saving" dense outlined color="#d9363e"/></v-col>
          </v-row>
          <p class="mg-help">保存后同步更新本校区库存，并记录出入库流水。</p>
        </v-card-text>
        <v-card-actions class="fc-dialog-actions"><v-spacer/><v-btn :disabled="stockAdjustment.saving" @click="stockAdjustment.dialog=false" depressed>取消</v-btn><v-btn :loading="stockAdjustment.saving" :disabled="stockAdjustment.saving" @click="submitStockAdjustment" color="#d9363e" depressed class="fc-confirm">确定</v-btn></v-card-actions>
      </v-card>
    </v-dialog>
<imageViewer :show="imageViewerDialog.show" :imgSrc="imageViewerDialog.imgSrc" :imgWidth="imageViewerDialog.imgWidth"
		:imgHeight="imageViewerDialog.imgHeight" @cancel="imageViewerDialog.show=false"></imageViewer></div>
</template>

<script>
	import * as qiniu from 'qiniu-js'
	import global from '../../../config/global'
	import storage from "../../../config/storage"
	import utils from '../../../config/utils'
	import cutImageUpload from '../../../components/cut_image_upload.vue'
	import imageViewer from "../../../components/image_viewer.vue"
	import {EventBus} from '../../../config/eventBus'
	import {hasErpPageAccess, STOCK_PAGE} from '../../../config/goodsStock'
	export default {
		name: "goods-list",
		components:{ cutImageUpload,imageViewer },
		data() {
			return {
				stockShopName: '',
				stockInfo: { loading: false, loaded: false, error: '', quantities: {}, canChange: false },
				stockAdjustment: { dialog: false, saving: false, goodsName: '', currentStock: 0, form: {} },
				imgPrev: global.config.imgPre,
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: 'ERP管理中心',
						disabled: true
					},
					{
						text: '商品管理',
						disabled: true
					},
				],
				data: {
					total: 0,
					headers: [
						{
							text: '商品ID',
							value: 'id',
							sortable: false
						},
						{
							text: '商品名称',
							value: 'goodsName',
							sortable: false
						},
						{
							text: '主图',
							value: 'masterImg',
							sortable: false
						},
						
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				statusList:[{text:'全部',value:''},{text:'正常',value:'1'},{text:'作废',value:'0'}],
	
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					goodsName: "",
					status:"1",
	
				},
				add: {
					dialog: false,
					goods: {
						masterImg:"",
						goodsName: "",
					},
				},
				update: {
					dialog: false,
					goods: {
						id:"",
						goodsName: "",
						status:"",
						masterImg:"",
					}
				},
				imageViewerDialog:{
					show:false,
					imgSrc:"",
					imgWidth:"400",
					imgHeight:"400",
				}
			
			}
		},
		created() {
			this._goodsRequest = 0;
			this._stockRequest = 0;
			EventBus.$on('updateShop', this.onStockShopChanged);
			this.getTableDataList();
		},
		beforeDestroy() {
			this._goodsRequest++;
			this._stockRequest++;
			EventBus.$off('updateShop', this.onStockShopChanged);
		},
		computed: {
			canViewStock() {
				return hasErpPageAccess(global.routeTree, STOCK_PAGE);
			},
			goodsHeaders() {
				const headers = this.data.headers.slice();
				if (this.canViewStock) headers.splice(3, 0, {text:'当前校区库存', value:'currentStock', align:'end', sortable:false});
				return headers;
			}
		},
		methods: {
			onStockShopChanged() {
				this.stockAdjustment.dialog = false;
				this.getTableDataList();
			},
			stockQuantity(item) {
				const value = this.stockInfo.quantities[String(item.id)];
				return value === undefined ? '—' : value;
			},
			async fetchCurrentPageStock() {
				const request = ++this._stockRequest;
				this.stockInfo = {loading:false, loaded:false, error:'', quantities:{}, canChange:false};
				if (!this.canViewStock) return;
				const shopId = String(utils.getCurrentShopId() || '');
				const shop = storage.getCurrentShop();
				this.stockShopName = shop && shop.shopName || '';
				if (!shopId) { this.stockInfo.error = '请先选择校区，再查看库存'; return; }
				const ids = this.data.list.map(item => String(item.id));
				if (!ids.length) { this.stockInfo.loaded = true; return; }
				this.stockInfo.loading = true;
				try {
					const response = await this.axios.get('/erp/goods/stock/list/page/0/size/100?shopId='+encodeURIComponent(shopId)+'&goodsIds='+encodeURIComponent(ids.join(',')));
					if (request !== this._stockRequest || shopId !== String(utils.getCurrentShopId() || '')) return;
					const result = response && response.data;
					if (!result || result.code !== 200) throw new Error(result && result.message || '库存加载失败');
					const data = result.data;
					if (!data || !Array.isArray(data.list) || !Number.isInteger(Number(data.count)) || Number(data.count) < 0 || Number(data.count) > data.list.length) throw new Error('库存数据异常，请重试');
					const quantities = {};
					ids.forEach(id => { quantities[id] = 0; });
					data.list.forEach(item => {
						if (String(item.shopId) !== shopId || !ids.includes(String(item.goodsId))) throw new Error('库存数据与当前校区或商品不匹配');
						const quantity = Number(item.stock);
						if (item.stock === null || item.stock === undefined || item.stock === '' || !Number.isSafeInteger(quantity)) throw new Error('库存数量异常');
						quantities[String(item.goodsId)] += quantity;
					});
					this.stockInfo.quantities = quantities;
					this.stockInfo.canChange = data.canChangeStock === true;
					this.stockInfo.loaded = true;
				} catch (error) {
					if (request === this._stockRequest) this.stockInfo.error = error.message || '库存加载失败，请重试';
				} finally {
					if (request === this._stockRequest) this.stockInfo.loading = false;
				}
			},
			showStockAdjustment(item) {
				if (!this.canViewStock || !this.stockInfo.canChange || !this.stockInfo.loaded || this.stockInfo.loading) return;
				this.stockAdjustment = {
					dialog:true, saving:false, goodsName:item.goodsName, currentStock:this.stockQuantity(item),
					form:{goodsId:String(item.id), shopId:String(utils.getCurrentShopId() || ''), inOut:'1', quantity:'', bizUserName:'', memo:''}
				};
			},
			async submitStockAdjustment() {
				const adjustment = this.stockAdjustment;
				if (adjustment.saving) return;
				if (!this.canViewStock || !this.stockInfo.canChange) { this.$noty.error('没有库存调整权限'); return; }
				if (!adjustment.form.shopId || adjustment.form.shopId !== String(utils.getCurrentShopId() || '')) { this.$noty.error('校区已切换，请重新打开库存调整'); return; }
				if (!['1','2'].includes(adjustment.form.inOut)) { this.$noty.error('请选择入库或出库'); return; }
				const quantity = String(adjustment.form.quantity);
				if (!/^[1-9]\d*$/.test(quantity) || Number(quantity)>10000) { this.$noty.error('数量须为1至10000的整数'); return; }
				if (adjustment.form.inOut === '2' && Number(quantity)>Number(adjustment.currentStock)) { this.$noty.error('库存不足'); return; }
				adjustment.saving = true;
				try {
					const response = await this.axios.post('/erp/goods/stock/change', {...adjustment.form});
					if (!response || !response.data || response.data.code !== 200) throw new Error(response && response.data && response.data.message || '库存调整失败');
					adjustment.dialog = false;
					this.$noty.success('库存调整成功');
					await this.fetchCurrentPageStock();
				} catch (error) { this.$noty.error(error.message || '库存调整失败，请重试'); }
				finally { adjustment.saving = false; }
			},
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			addUploadSuccess(res){
				// 主图上传完成
				console.log(res);
				this.add.goods.masterImg = res.key;
			},
			showImageViewer(imgSrc){
				this.imageViewerDialog.imgSrc = imgSrc;
				this.imageViewerDialog.show=true;
			},
			showAddDialog() {
				this.add.dialog = true;
				
				// 清空add历史数据
				this.add.goods.goodsName = "";
				
				this.add.goods.masterImg = '';
				
			},
			editUploadSuccess(res){
				this.update.goods.masterImg = res.key;
			},
			getTableDataList() {
				const that = this;
				const request = ++this._goodsRequest;
				this._stockRequest++;
				this.stockInfo = {loading:false, loaded:false, error:'', quantities:{}, canChange:false};
				this.query.loading = true;


				let url = `/erp/goods/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.goodsName) {
					url += "&goodsName=" + this.query.goodsName;
				}
				if (this.query.status) {
					url += "&status=" + this.query.status;
				}
				
				this.axios.get(url).then(response => {
					if (request !== this._goodsRequest) return;
					
					console.log(response);
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						that.fetchCurrentPageStock();
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				}).catch(() => {
					if (request !== this._goodsRequest) return;
					that.query.loading = false;
					that.$noty.error('商品加载失败，请重试');
				})
			},
			classStatusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "作废";
				}
				return stName;
			},
			classStatusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			submitAddClass() {

				if (!this.add.goods.goodsName) {
					this.$noty.error('商品名称不能为空');
					return
				}
				
				if(!this.add.goods.masterImg){
					this.$noty.error('请上传商品图片');
					return
				}
				
				let imgList = []; // 上传的图片KEY
				imgList.push(this.add.goods.masterImg);
				
		
			
				// api
				const that = this;
				let url = `/erp/goods/create`;
				let postData = {...this.add.goods};
				postData.imgList = imgList;
				
			

				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});

			},
			showUpdate(item) {
				
				console.log(item);
				this.update.dialog = true;
				this.update.goods.id = item.id;
				this.update.goods.goodsName = item.goodsName;
				this.update.goods.status = item.status;
				this.update.goods.masterImg =  item.masterImg;
			},
			submitUpdateGoods() {

				if (!this.update.goods.id) {
					this.$noty.error('ID不能为空');
					return
				}
				if (!this.update.goods.goodsName) {
					this.$noty.error('商品名称不能为空');
					return
				}
				
				if(!this.update.goods.masterImg){
					this.$noty.error('请上传商品图片');
					return
				}
				
				let imgList = []; // 上传的图片KEY
				imgList.push(this.update.goods.masterImg);
	
				
				// api
				const that = this;
				let url = `/erp/goods/update`;
			
				// parameters
				
				const updateData = {
					...this.update.goods
				}
				updateData.imgList = imgList;
				
				this.axios.post(url, updateData).catch(() => {
						that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.update.dialog = false;
							that.getTableDataList();
							
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});
			},
			// 修改商品状态
			changeStatus(item,newStatus){
				// api
				const that = this;
				let url = `/erp/goods/status`;
							
				// parameters
				
				const updateData = {
					id:item.id,
					status:newStatus
				}
				
				this.axios.post(url, updateData).catch(() => {
						that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.getTableDataList();
							
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
			}
		}
	}
</script>
<style>
</style>
<style lang="scss" scoped src="../../../assets/styles/management.scss"></style>
